module.exports = __webpack_public_path__ + "assets/img/yd2.0417b5f0.png";